import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { makeStyles } from '@mui/styles';
import { DropdownOption, CustomSetting } from 'types/types';

const useStyles = makeStyles((theme) => ({
  textField: {
    paddingTop: theme.spacing(0.5),
    width: '45%',
    paddingBottom: theme.spacing(2)
  },
  deleteIcon: {
    color: theme.palette.error.main
  }
}));

type CheckboxSectionProps = {
  inputSetting: CustomSetting;
  initialSelectValue: Array<DropdownOption> | object;
  setSave: React.Dispatch<
    React.SetStateAction<Record<string, string | boolean>>
  >;
};

export const CheckboxSection: React.FC<CheckboxSectionProps> = ({
  inputSetting,
  initialSelectValue,
  setSave
}: CheckboxSectionProps) => {
  let matchObjects: Array<DropdownOption> | undefined;
  if (Array.isArray(initialSelectValue)) {
    const selectedOptionsMap = new Map(
      initialSelectValue?.map((item: any) => [
        `${item.value}-${item.label}`,
        item
      ])
    );
    matchObjects = inputSetting?.dropdownOptions?.filter((option: any) =>
      selectedOptionsMap?.has(`${option.value}-${option.label}`)
    );
  }

  const [selectedOptions, setSelectedOptions] = React.useState(
    matchObjects ? matchObjects : []
  );
  const classes = useStyles();

  const handleChange = React.useCallback((event: any, value: any) => {
    setSelectedOptions(value);
  }, []);
  React.useEffect(() => {
    if (inputSetting?.id === undefined) return;
    const id = inputSetting.id;
    setSave((prev: any) => ({ ...prev, [id]: selectedOptions }));
  }, [setSave, selectedOptions, inputSetting?.id]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      data-testid="render-checkbox-components"
      className={classes.textField}
      onChange={handleChange}
      options={inputSetting?.dropdownOptions || []}
      disableCloseOnSelect
      getOptionLabel={(option: any) => option.label}
      value={selectedOptions}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
          {option?.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={inputSetting?.title}
          helperText={inputSetting?.helperTextValue}
        />
      )}
      ChipProps={{
        classes: { deleteIcon: classes.deleteIcon }
      }}
    />
  );
};
